import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AuthResponse,
  CreateAdvisorRequest,
  CreateCustomerRequest,
  UpdateContactRequest,
  UserProfileResponse,
} from '../types/users-management';

const UsersManagementEndpoints = {
  CREATE_CUSTOMER: 'api/v1/users/create-customer',
  CREATE_FINANCIAL_ADVISOR: 'api/v1/users/create-financial-advisor',
  PROFILE: 'api/v1/users/profile',
  CONTACT_INFO: 'api/v1/users/contact-info',
};

@Injectable({
  providedIn: 'root',
})
export class UsersManagementService {
  private readonly httpClient = inject(HttpClient);

  createCustomer(request: CreateCustomerRequest) {
    return this.httpClient.post<AuthResponse>(UsersManagementEndpoints.CREATE_CUSTOMER, request);
  }

  createFinancialAdvisor(request: CreateAdvisorRequest) {
    return this.httpClient.post<void>(UsersManagementEndpoints.CREATE_FINANCIAL_ADVISOR, request);
  }

  getProfile() {
    return this.httpClient.get<UserProfileResponse>(UsersManagementEndpoints.PROFILE);
  }

  updateContactInfo(request: UpdateContactRequest) {
    return this.httpClient.patch<UserProfileResponse>(UsersManagementEndpoints.CONTACT_INFO, request);
  }
}
